const getters = {
  isLoading (state) {
    return state.isLoading
  },
  isAuthenticated (state) {
    return state.isAuthenticated
  },
  currentCompanyId (state) {
    return state.currentCompanyId
  },
  abilities (state) {
    return state.abilities
  }
}

export default getters
